export default __webpack_public_path__ + "static/media/expert@2x.6c7fefeb.png";